import { render, staticRenderFns } from "./VehicleType.vue?vue&type=template&id=42ed9ac4&scoped=true&"
import script from "./VehicleType.vue?vue&type=script&lang=js&"
export * from "./VehicleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed9ac4",
  null
  
)

export default component.exports